import { UserSettings } from "@/features/user-settings";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/_fixed-sidebar/user-settings"
)({
  component: UserSettingsPage
});

function UserSettingsPage() {
  return <UserSettings />;
}
